import { render, staticRenderFns } from "./filter-assignment.component.vue?vue&type=template&id=b17fcd1a&scoped=true&"
import script from "./filter-assignment.component.vue?vue&type=script&lang=ts&"
export * from "./filter-assignment.component.vue?vue&type=script&lang=ts&"
import style0 from "./filter-assignment.component.vue?vue&type=style&index=0&id=b17fcd1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17fcd1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
